import { DateTime } from 'luxon';
import { AssetType } from '../constants';
import { Asset, AssetWithDimensions } from '../types';

export function shouldPollForMissingThumbnail(asset: Asset | AssetWithDimensions, minutesToKeepPolling = 5): boolean {
    if (asset.type === AssetType.Folder || asset.thumbnailUrl) {
        return false;
    }
    const now = DateTime.now();
    const assetDateAdded = DateTime.fromISO(asset.dateAdded);
    const { minutes } = now.diff(assetDateAdded, 'minutes');
    return minutes < minutesToKeepPolling;
}
